import Vue from 'vue';
import App from './App.vue';
import vuetify from '@/plugins/vuetify';
// import '@mdi/font/css/materialdesignicons.css'
import './plugins/axios'
import router from './router';
import store from './store/store';
import VueMuuri from 'vue-muuri'
import { MessageBox, Message } from 'element-ui';
import VueClipboard from 'vue-clipboard2'
import TextHighlight from 'vue-text-highlight';
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'vue-muuri/dist/vue-muuri.css';
import 'element-ui/lib/theme-chalk/index.css';
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
 
import './assets/css/common.css';
import './assets/css/mobile.css';
import './assets/css/flags.css';
Vue.component('text-highlight', TextHighlight);

Vue.use(VXETable)

Vue.use(VueMuuri)
Vue.use(VueClipboard)
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$message = Message
Vue.config.productionTip = false

//导出的方法

new Vue({
  router,
  store, 
  vuetify,
  icons: {
    iconfont: 'mdiSvg',
  },
  render: h => h(App),
}).$mount('#app')
